import {
    SELECTION_SCOPE_HALL,
    SELECTION_SCOPE_SECTOR,
    SELECTION_SCOPE_ROW,
    SELECTION_SCOPE_ROUND_TABLE,
    SELECTION_SCOPE_RECTANGLE_TABLE,
} from '%paysera_seat_selection/js/seatSelection/constants/selectionScope';

export default (
    {
        Hall,
        Sector,
        Row,
        RoundTable,
        RectangleTable,
    },
    { scope, parent },
) => {
    if (parent === null) {
        return [];
    }

    const { id } = parent;

    if (scope === SELECTION_SCOPE_HALL) {
        const hall = Hall.all().first();
        return [].concat(
            hall.sectors.toModelArray(),
            hall.roundTables.toModelArray(),
            hall.rectangleTables.toModelArray(),
            hall.generalAdmissions.toModelArray(),
            hall.shapes.toModelArray(),
        );
    }
    if (scope === SELECTION_SCOPE_SECTOR) {
        const sector = Sector.withId(id);
        if (sector === null) {
            return [];
        }
        return sector.rows.toModelArray();
    }
    if (scope === SELECTION_SCOPE_ROUND_TABLE) {
        const table = RoundTable.withId(id);
        if (table === null) {
            return [];
        }
        return table.seats.toModelArray();
    }
    if (scope === SELECTION_SCOPE_RECTANGLE_TABLE) {
        const table = RectangleTable.withId(id);
        if (table === null) {
            return [];
        }
        return table.seats.toModelArray();
    }
    if (scope === SELECTION_SCOPE_ROW) {
        const row = Row.withId(id);
        if (row === null) {
            return [];
        }
        return row.seats.toModelArray();
    }

    return [];
};
